export type ScoreComponents = { hard: number; medium: number; soft: number };

export const getScoreComponents = (score?: string | null): ScoreComponents => {
    const components: ScoreComponents = { hard: 0, medium: 0, soft: 0 };
    if (!score) return components;
    const regex = /(-?\d*(?:\.\d+)?)(hard|medium|soft)/g;
    const matches = [...score.matchAll(regex)];
    for (const m of matches) {
        const val = Number.parseFloat(m[1] || "0");
        const tier = m[2] as keyof ScoreComponents;
        components[tier] = val;
    }
    return components;
};

